import { render, staticRenderFns } from "./addRoleU.vue?vue&type=template&id=37d7019b"
import script from "./addRoleU.vue?vue&type=script&lang=js"
export * from "./addRoleU.vue?vue&type=script&lang=js"
import style0 from "./addRoleU.vue?vue&type=style&index=0&id=37d7019b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports